module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('ul', [_c('li', [_c('div', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "padding-left": "0.75rem"
    }
  }, [_c('div', [_c('div', {
    staticClass: "item-title tip"
  }, [_vm._v("请上传名片正面或身份证正反面")]), _vm._v(" "), _c('div', {
    staticClass: "item id-card"
  }, [_c('div', {
    staticClass: "show-image"
  }, [(_vm.avatarPositive === '') ? _c('span', {
    staticClass: "add-card"
  }, [_vm._v("+添加正面")]) : _c('img', {
    staticStyle: {
      "height": "146px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.avatarPositive
    }
  })]), _vm._v(" "), _c('input', {
    ref: "avatarInputPosi",
    staticClass: "input",
    attrs: {
      "type": "file",
      "name": "positive",
      "accept": "image/jpg,image/jpeg,image/png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImagePositive($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item id-card"
  }, [_c('div', {
    staticClass: "show-image"
  }, [(_vm.avatarNegative === '') ? _c('span', {
    staticClass: "add-card"
  }, [_vm._v("+添加反面")]) : _c('img', {
    staticStyle: {
      "height": "146px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.avatarNegative
    }
  })]), _vm._v(" "), _c('input', {
    ref: "avatarInputNega",
    staticClass: "input",
    attrs: {
      "type": "file",
      "name": "negative",
      "accept": "image/jpg,image/jpeg,image.png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImageNegative($event)
      }
    }
  })])])])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger external",
    class: {
      'disabled': _vm.disable
    },
    attrs: {
      "href": _vm.href,
      "disabled": _vm.disable
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("提交")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("申请信用支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("注：")]), _vm._v(" "), _c('div', {
    staticClass: "id-p"
  }, [_c('p', [_vm._v("1.请上传清晰的名片正面或身份证正面及反面。")])]), _vm._v(" "), _c('div', {
    staticClass: "id-p"
  }, [_c('p', [_vm._v("2.照片大小不超过5MB，支持照片格式jpg，jpeg，png。")])]), _vm._v(" "), _c('div', {
    staticClass: "id-p"
  }, [_c('p', [_vm._v("3.吉凯基因淘基因向您承诺：您的身份证信息仅用作申请信用付款验证，我们绝不外漏！")])]), _vm._v(" "), _c('div', {
    staticClass: "id-p"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-0.3rem"
    }
  }, [_vm._v("4.在您提交认证申请后，我们将在两个工作日内完成审核，审核成功后，根据具体情况，您可以获得\n                    "), _c('strong', {
    staticStyle: {
      "color": "#f6383a"
    }
  }, [_vm._v("10000元")]), _vm._v("或"), _c('strong', {
    staticStyle: {
      "color": "#f6383a"
    }
  }, [_vm._v("50000元")]), _vm._v("的信用额度。请您在\"个人中心-我的信用\"中查看您的信用额度。")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dde62604","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyCredit/ApplyCreditPay.vue
// module id = 1732
// module chunks = 8